import * as React from "react";

export function VpisIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || "currentColor";
  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 150" {...props}>
      <path fill="none" d="M-1-1h162v152H-1z" />
      <g>
        <path
          d="M15.001 75.013h0c0-36.409 29.373-65.924 65.605-65.924h0c17.4 0 34.087 6.945 46.39 19.308 12.304 12.364 19.216 29.132 19.216 46.616h0c0 36.408-29.373 65.924-65.606 65.924h0c-36.232 0-65.605-29.516-65.605-65.924zM80.606 9.089v131.848M15.001 75.013h131.21"
          strokeWidth={16}
          stroke={color}
          fill="none"
        />
        <path
          d="M25.181 74.904c0-30.78 24.668-55.734 55.096-55.734 14.613 0 28.626 5.872 38.959 16.325 10.333 10.451 16.137 24.628 16.137 39.41 0 30.78-24.667 55.733-55.096 55.733-30.428 0-55.096-24.953-55.096-55.734zM80.277 19.17v111.468M25.18 74.904h110.192"
          fill="none"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={13}
          stroke={color}
          fill="none"
          d="M14.586 76.051l132.484 1.274M93.567 55.669v42.675"
        />
        <path fill="none" d="M80.828 55.669v42.675" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={13}
          stroke={color}
          fill="none"
          d="M68.089 55.669v42.675"
        />
      </g>
    </svg>
  );
}
